import * as type from '../actions/types';

const initialState = {
    reviews: {},
    loading: false,
    error: null,
}

export default function customerReviews(state = initialState, action) {
    switch (action.type) {
        case type.GET_CUSTOMER_REVIEWS_REQUESTED:
            return {
                ...state,
                loading: true,
            }
        case type.GET_CUSTOMER_REVIEWS_SUCCESS:
            return {
                ...state,
                loading: false,
                reviews: action.data,
            }
        case type.GET_CUSTOMER_REVIEWS_FAILED:
            return {
                ...state,
                loading: false,
                error: action.message,
            }
        default:
            return state
    }
}